var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColmidDef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 271,
    viewBox: "0 0 271 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 271,
    height: 271,
    rx: 135.5,
    fill: "#ECE6F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 223,
    height: 223,
    rx: 111.5,
    fill: "#C3B0DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 51,
    width: 170,
    height: 170,
    rx: 85,
    fill: "#3F0099"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0174 135.259C80.0174 138.598 78.1314 140.943 73.5184 140.943H69.1858V147.442H66V129.602H73.5184C78.1314 129.602 80.0174 131.946 80.0174 135.259ZM76.8061 135.259C76.8061 133.17 75.7867 132.023 73.3655 132.023H69.1858V138.522H73.3655C75.7867 138.522 76.8061 137.375 76.8061 135.259Z",
    fill: "#EDFBF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3227 129.602H88.7002L93.1094 146.244L97.442 129.602H102.82V147.442H99.7358V131.258L95.3267 147.442H90.8411L86.381 131.054V147.442H83.3227V129.602Z",
    fill: "#EDFBF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.007 129.602H146.058H151.435L154.086 146.575L157.527 129.602H160.738L156.685 147.442H151.435L148.657 130.57L146.007 147.442H140.757L136.704 129.602H139.916L143.356 146.524L146.007 129.602Z",
    fill: "#EDFBF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.262 147.442L173.115 143.39H165.648L164.45 147.442H161.239L166.565 129.602H172.555L177.601 147.442H174.262ZM169.445 130.519L166.285 141.249H172.504L169.445 130.519Z",
    fill: "#EDFBF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.049 129.602H196.108V147.442H190.705L183.721 130.57V147.442H180.663V129.602H186.066L193.049 146.473V129.602Z",
    fill: "#EDFBF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.699 129.602H203.884V147.442H200.699V129.602Z",
    fill: "#EDFBF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.818 141.78L120.138 147.46L114.338 141.66C115.906 140.092 117.977 139.326 120.048 139.347C122.126 139.367 124.212 140.181 125.815 141.784L125.818 141.78Z",
    fill: "#48D6C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.263 132.398L130.567 137.094C127.635 134.162 123.815 132.671 120.003 132.634C116.204 132.596 112.413 134.005 109.545 136.873L104.77 132.098C108.937 127.93 114.435 125.878 119.951 125.935C125.47 125.99 131.009 128.15 135.26 132.401L135.263 132.398Z",
    fill: "#48D6C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.818 141.78L120.138 147.46L114.338 141.66C115.906 140.092 117.976 139.326 120.048 139.347C122.126 139.367 124.212 140.181 125.814 141.784L125.818 141.78Z",
    fill: "#48D6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColmidDef);
export default __webpack_public_path__ + "static/media/colmidDef.84113ac1a55ed6347502d31ebaef2a96.svg";
export { ForwardRef as ReactComponent };